<template>
  <div id="app">
    <Loading />
    <template v-if="$store.getters.getLoadingView === false">
      <router-view :key="$route.path"/>
    </template>
    <OpaAlert />
  </div>
</template>

<script>
/* global NATIVE */
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import OffersConn from '@/connection/offers'
import Loading from '@/components/Loading.vue'
import ScrollBehaviour from '@/behaviours/ScrollBehaviour.js'
import OpaAlert from '@/components/OpaAlert'
import UserConn from '@/connection/user'


export default {
  name: 'App',
  mixins: [ScrollBehaviour],
  components: {
    Loading, OpaAlert // TransitionPage
  },

  async created () {
    // get all lists to offers
    // if has offers, the home page will show the links
    // to activate the offers

    // if (!this.$store.state.company.market_place){

       await OffersConn.getAllOffers()
    // }

  },
  async mounted () {
    //remove preload
    let preloader = document.getElementById('preload')
    if(preloader){
      preloader.remove()
    }

    // wait 30 seconds before take status
    if (NATIVE === true && this.$store.state.company.onSignalKeys && this.$store.state.company.onSignalKeys.appId) {
      setTimeout(async function() {
        console.log('one signal native')
        window.plugins.OneSignal.getPermissionSubscriptionState(function (status) {
          console.log(JSON.stringify(status))
          if (status.subscriptionStatus.userId) {
            console.log('!!!!!!! PUSH ID' + status.subscriptionStatus.userId)
            localStorage.setItem('pushUserId', status.subscriptionStatus.userId)
          } else {
            console.log('!!!! NO PUSH STATUS')
          }
        });
        // if user is logged in and have push id to update
        await UserConn.updateUserInfo()
      }, 30000)
    } else if (NATIVE === false && this.$store.state.company.onSignalKeys && this.$store.state.company.onSignalKeys.appId) {
      await UserConn.updateUserInfo()
    } else {
      await UserConn.sendUserIdKonduto()
    }
  }
}
</script>


<style>

* {
  user-select: none;
  -webkit-user-select: none;
  -webkit-user-callout: none;
  -webkit-touch-callout: none;
}

input, textarea {
  -webkit-user-select: text;
  -webkit-user-callout: default;
  -webkit-touch-callout: default;
}

@font-face {
  font-family: "Roboto";
  src: url("assets/Roboto-Regular.ttf");
}

@font-face {
  font-family: "Roboto-Medium";
  src: url("assets/Roboto-Medium.ttf");
}

@font-face {
  src: url("assets/Nunito-Bold.ttf");
  font-family: "Nunito-Bold";
}

@font-face {
  src: url("assets/Nunito-ExtraBold.ttf");
  font-family: "Nunito-ExtraBold";
}

@font-face {
  src: url("assets/Nunito-Black.ttf");
  font-family: "Nunito-Black";
}


button {
  font-family: 'Roboto-Medium';
}

button.wire {
  border-radius: 10px;
  width: 100%;
  max-width: 311px;
  height: 44px;
  border: 1px solid;
  font-size: 16px;
}

button.solid {
  border-radius: 10px;
  width: 100%;
  max-width: 311px;
  height: 44px;
  border: 0px;
  font-size: 16px;
  color: #ffffff;
  }

select {
  color:#000000!important;
  background-color: #fff!important;
  margin-bottom:2px;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
  /* max-width:1330px; */
  padding:0px;
  margin: 0 auto;
  background-color: #ffffff;
  font-family: "Roboto";
}


.inputText {
  border: 1px solid #3A332C;
  border-radius: 4px;
  padding: 5px;
  font-size: 18px;
  line-height: 23px;
  background-color: #ffffff;
}

.wire{
  background-color: transparent;
}

.search {
  padding-right:40px;
}

.shadow {
  -webkit-box-shadow:1px 2px 5px rgba(0, 0, 0, 0.4);
  -moz-box-shadow:1px 2px 5px rgba(0, 0, 0, 0.4);
  box-shadow:1px 2px 5px rgba(0, 0, 0, 0.4);

  -webkit-animation: fadeInFromNone 0.5s ease-out;
    -moz-animation: fadeInFromNone 0.5s ease-out;
    -o-animation: fadeInFromNone 0.5s ease-out;
    animation: fadeInFromNone 0.5s ease-out;
}


@-webkit-keyframes fadeInFromNone {
    0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 1;
    }
}

@-moz-keyframes fadeInFromNone {
    0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 1;
    }
}

@-o-keyframes fadeInFromNone {
    0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 1;
    }
}

@keyframes fadeInFromNone {
    0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 1;
    }
}

</style>
